import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const VozidloTisk = lazy(() =>
  import('@/modules/vozidla/VozidloTisk').then((m) => ({ default: m.VozidloTisk })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/$id/tisk',
  component: () => (
    <Suspense fallback={null}>
      <VozidloTisk />
    </Suspense>
  ),
});
